import { createAsyncThunk } from "@reduxjs/toolkit";
import { openMessage } from "../slice/messageSlice";
import { openForm } from "../slice/userSlice";
import { editUserDetail, getUserDetailPage, postUserDetail } from "./userDetailAction";
import { API_ACCOUNT, API_MASTER } from "../../constants";

export const getUserPage = createAsyncThunk(
  "user/page",
  async (param, thunkAPI) => {
    const respone = await fetch(
      `${API_ACCOUNT}/api/user/page`,
      // ?page=${param.page}&size=${param.size}&sort=${param.select},${param.sort}&${param.select}=${param.filter}
      {
        method: "get",
        headers: new Headers({
          Authorization: "Bearer " + param.token,
          //    + param.token,
          Accept: "application/json",
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Credentials": "true",
        }),
      }
    );
    if (respone.status === 200) {
      const responeResult = await respone.json();
      // console.log("as")
      return responeResult;
    } else {
      return {
        data: {
          content: [],
          totalElements: 0,
          totalPages: 0,
          last: true,
          size: 0,
          number: 0,
          numberOfElements: 0,
          first: true,
          empty: false,
        },
      };
    }
  }
);

export const postUser = createAsyncThunk(
  "user/post",
  async (param, thunkAPI) => {
    // console.log(param);
    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: "Bearer " + param.token,
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Credentials": "true",
      },
      body: JSON.stringify(param.data),
    };
    let response = await fetch(
      `${API_ACCOUNT}/api/user`,
      requestOptions
    );
    if (response.status === 200) {
      thunkAPI.dispatch(
        openMessage({
          message: "Insert User Successfull",
          type: "success",
          open: true,
        })
      );
      thunkAPI.dispatch(getUserPage(param));
    }
    // .then(getApi())
  }
);

export const editUser = createAsyncThunk(
  "user/update",
  async (param, thunkAPI) => {
    console.log(param);
    const requestOptions = {
      method: "PUT",
      headers: {
        Authorization: "Bearer " + param.token,
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Credentials": "true",
      },
      body: JSON.stringify(param.data),
    };
    let response = await fetch(
      `${API_ACCOUNT}/api/user/${param.id}`,
      requestOptions
    );
    if (response.status === 200) {
      thunkAPI.dispatch(
        openMessage({ message: 'Berhasil Mengubah User', type: 'success', open: true }),
      )
      thunkAPI.dispatch(getUserPage(param))
    }
    if (response.status === 400) {
      thunkAPI.dispatch(openMessage({ message: 'Edit User Failed', type: 'danger', open: true }))
    }
  }
);

export const deleteUser = createAsyncThunk(
  "user/delete",
  async (param, thunkAPI) => {
    // console.log(param);
    const requestOptions = {
      method: "DELETE",
      headers: {
        Authorization: "Bearer " + param.token,
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Credentials": "true",
      },
      body: JSON.stringify(param.data),
    };
    let response = await fetch(
      `${API_MASTER}/api/user/${param.id}`,
      requestOptions
    );
    if (response.status === 200) {
      thunkAPI.dispatch(
        openForm({ state: "delete", open: false, id: "", data: [] })
      );
      thunkAPI.dispatch(
        openMessage({
          message: "Delete User Successfull",
          type: "success",
          open: true,
        })
      );
      thunkAPI.dispatch(getUserPage(param));
    }
    // .then(getApi())
  }
);


export const postUserPlusDetail = createAsyncThunk(
  'userplus/post',
  async (param, thunkAPI) => {
    const bodyUser = {
      username: param.bodyUser.username,
      password: param.bodyUser.password,
      roleId: param.bodyUser.roleId,
    }
    // console.log(bodyCor)
    const requestOptions = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + param.token,
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Credentials': 'true',
      },
      body: JSON.stringify(bodyUser),
    }

    let response = await fetch(`${API_ACCOUNT}/api/user`, requestOptions)
    console.log(param.bodyUser)
    if (response.status === 200) {
      const responseJson = await response.json()
      const idUser = responseJson.data.id
      console.log(responseJson)
      const bodyAss = {
        userId: idUser,
        firstName: param.bodyUser.firstName,
        lastName: param.bodyUser.lastName,
        phone: param.bodyUser.phone,
        address: param.bodyUser.address,
        siteId: param.bodyUser.siteId,
      }
      // idTicketCorrective +  bodyAssigment =
      // for (let i = 0; i < assigment.length; i++) {
      // }
        // console.log('jangan')
        thunkAPI.dispatch(postUserDetail({ token: param.token, data: bodyAss }))
      thunkAPI.dispatch(
        openMessage({
          message: 'Berhasil Menambahkan User',
          type: 'success',
          open: true,
        }),
      )
      thunkAPI.dispatch(getUserPage(param))
    }
    // .then(getApi())
  },
)

export const editUserPlusDetail = createAsyncThunk(
  'userplus/edit',
  async (param, thunkAPI) => {
    const bodyUser = {
      username: param.bodyUser.username,
      roleId: param.bodyUser.roleId,
    }
    // console.log(bodyCor)
    const requestOptions = {
      method: 'PUT',
      headers: {
        Authorization: 'Bearer ' + param.token,
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Credentials': 'true',
      },
      body: JSON.stringify(bodyUser),
    }
    console.log(param.id)

    let response = await fetch(`${API_ACCOUNT}/api/user/${param.userId}`, requestOptions)
    // console.log(param.bodyCorrective)
    if (response.status === 200) {
      const responseJson = await response.json()
      const idUser = responseJson.data.id
      // console.log(responseJson)
      const bodyAss = {
        userId: idUser,
        firstName: param.bodyUser.firstName,
        lastName: param.bodyUser.lastName,
        phone: param.bodyUser.phone,
        address: param.bodyUser.address,
        sitesId: param.bodyUser.sitesId,
      }
      // idTicketCorrective +  bodyAssigment =
      // for (let i = 0; i < assigment.length; i++) {
      // }
        // console.log('jangan')
        thunkAPI.dispatch(editUserDetail({ token: param.token,id: param.id, data: bodyAss }))
      thunkAPI.dispatch(
        openMessage({
          message: 'Berhasil Menugubah Detail User',
          type: 'success',
          open: true,
        }),
      )
      thunkAPI.dispatch(getUserDetailPage(param))
    }
    // .then(getApi())
  },
)

